import styled from "styled-components";
import {dialogTextMixin} from "../../../../modal-dialog/boxes/text/dialog-text.box";

export const RadioInputLabelBox = styled.label`
    padding-left: 15px;
    ${dialogTextMixin}
`;